package pl.decks.personal.components.layouts.site

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.widgets.mail.MailLink
import pl.decks.personal.styles.SiteLayout
import pl.decks.posthog.client.PostHogClient
import kotlin.js.Date

@Composable
internal fun Footer(isCopyright: Boolean) = Column(
    modifier = SiteLayoutStylesheet.Footer.Style.toModifier(),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    Row(SiteLayoutStylesheet.Footer.CreatedWith.toModifier()) {
        SpanText("This site is ")
        Link(
            path = "https://gitlab.com/TheDecks/personal-site",
            text = "open source",
            modifier = Modifier
                .onClick { PostHogClient.capture(SiteNavigationJourney.SourceCodeVisited) }
        )
        SpanText(", built with ")
        Link("https://github.com/varabyte/kobweb", "Kobweb")
        SpanText(".")
    }
    Row(SiteLayoutStylesheet.Footer.Copyright.toModifier().gap(SiteLayout.Space.Medium)) {
        if (isCopyright) {
            val currentYear = Date().getFullYear()
            SpanText("© $currentYear, Pi Blaz")
        }
        MailLink()
    }
}
